module.exports = __webpack_public_path__ + "img/om-partnership-logo.45b7279c.svg";